import { gql } from "@apollo/client";

export const GET_ALL_CALIFICACIONES_MONITOREO = gql`
query claseMonitoreo {
    claseMonitoreo
    {
        idClaseMonitoreo
        descripcion
    }
}`;

export const adaptCalificacionMonitoreo = (claseMonitoreo) => {
  return {
    id: claseMonitoreo?.idClaseMonitoreo,
    displayName: claseMonitoreo?.descripcion

  };
};

const adaptCalificacionesMonitoreoArray = (clasesMonitoreo) => {

  return structuredClone(clasesMonitoreo?.claseMonitoreo)?.
  map((claseMonitoreo) => adaptCalificacionMonitoreo(claseMonitoreo)) || [];
};

export default adaptCalificacionesMonitoreoArray;